export default __webpack_public_path__ + "static/media/woo.7f42ce44.svg";